module.exports = __webpack_public_path__ + "static/media/galerija_2023 (6).c323a054.png";